var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.hint,
    //show:true,
    show: _vm.wordIsSelected,
    offset: 20,
    placement: this.computedPlacement,
    trigger: 'manual',
    classes: [_vm.className, 'tooltip-word', ("tooltip-" + (_vm.index + 1)), ("" + _vm.computedColor), "br2 ph2 pv1 mb0 mt0 pl2 pr2 f4-l f5-m f5"],
  }),expression:"{\n    content: hint,\n    //show:true,\n    show: wordIsSelected,\n    offset: 20,\n    placement: this.computedPlacement,\n    trigger: 'manual',\n    classes: [className, 'tooltip-word', `tooltip-${index + 1}`, `${computedColor}`, `br2 ph2 pv1 mb0 mt0 pl2 pr2 f4-l f5-m f5`],\n  }"}],class:[_vm.className, _vm.isValid && 'valid', , ("" + _vm.computedColor)],style:(_vm.gridStyles)})}
var staticRenderFns = []

export { render, staticRenderFns }